export const useKeyboardEventHandler = (strategies: any = {}) => {
  const onKeyboardEvent = (event: any) => {
    const noop = () => {};
    const fn = strategies[event.key] || noop;
    fn(event);
  };

  return {
    onKeyboardEvent,
  };
};

export default useKeyboardEventHandler;
